export default "__VITE_ASSET__BNrt4Txk__"